/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput, ArtifactUploaderInputProps } from 'domain/shared/artifact/input';

const CareerDevelopmentReviewAttachmentUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.CAREER_DEVELOPMENT_REVIEW_ATTACHMENT} />;
};

export default CareerDevelopmentReviewAttachmentUploaderInput;
